import React from 'react';
import ConfirmationDialogDecorator from 'relements/build/esm/decorators/confirmationDialog';
import { closeConfirmationDialog } from 'actions/BotActions';

@ConfirmationDialogDecorator()
export default class ConfirmationDialog extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (!this.props.active && nextProps.active) {
      const {
        title,
        message,
        okTitle,
        cancelTitle,
        okActionType,
        cancelActionType,
        successCallback,
      } = nextProps;
      this.props.activateConfirmationDialog(
        {
          title: title || 'Confirm',
          message: message || 'Do you want to continue?',
          positiveText: okTitle,
          negativeText: cancelTitle,
          primaryActionType: okActionType,
          secondaryActionType: cancelActionType,
          themed: true,
        },
        this._onCallback
      );
    }
  }

  _onCallback = (success) => {
    if (success) {
      this.props.successCallback(this.props.data);
    } else if (this.props.cancelCallback) this.props.cancelCallback();
    closeConfirmationDialog();
  };

  render() {
    return null;
  }
}
